import { render, staticRenderFns } from "./RoutingStatusSelector.vue?vue&type=template&id=fe85b164"
import script from "./RoutingStatusSelector.vue?vue&type=script&lang=js"
export * from "./RoutingStatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports